import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';

export const PaymentMethodForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.paymentMethodCode_column_name,
      value: '',
      autoFocus: true,
      type: 'text',
      placeholder: '',
      field: 'code',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      disabled: true,
    },
    {
      label: strings.paymentMethodName_column_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
  ];
};
